import { recordToLang } from '@platform/front-utils';
import startPage from './startPage';

const lang: Record<string, string> = recordToLang(
    {
        productTitle: 'Модуль сбора и обработки заявок',
        startPage,
    },
    false,
);

export default lang;
